import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import classes from './styles.module.css';

// Маппинг действий на русский язык
const ACTION_LABELS = {
    account_create: 'AuditLogs.action.account_create',
    account_update: 'AuditLogs.action.account_update',
    account_delete: 'AuditLogs.action.account_delete',
    account_login: 'AuditLogs.action.account_login',
    account_logout: 'AuditLogs.action.account_logout',
    account_grant_admin: 'AuditLogs.action.account_grant_admin',
    account_revoke_admin: 'AuditLogs.action.account_revoke_admin',
    account_reset_2fa: 'AuditLogs.action.account_reset_2fa',
    account_password_reset: 'AuditLogs.action.account_password_reset',
    account_project_add: 'AuditLogs.action.account_project_add',
    account_project_remove: 'AuditLogs.action.account_project_remove',
    merchant_create: 'AuditLogs.action.merchant_create',
    merchant_update: 'AuditLogs.action.merchant_update',
    merchant_delete: 'AuditLogs.action.merchant_delete',
    merchant_block: 'AuditLogs.action.merchant_block',
    merchant_unblock: 'AuditLogs.action.merchant_unblock',
    merchant_frod_update: 'AuditLogs.action.merchant_frod_update',
    merchant_widget_update: 'AuditLogs.action.merchant_widget_update',
    merchant_user_add: 'AuditLogs.action.merchant_user_add',
    merchant_user_remove: 'AuditLogs.action.merchant_user_remove',
    terminal_create: 'AuditLogs.action.terminal_create',
    terminal_update: 'AuditLogs.action.terminal_update',
    terminal_delete: 'AuditLogs.action.terminal_delete',
    terminal_balance_sync: 'AuditLogs.action.terminal_balance_sync',
    terminal_status_change: 'AuditLogs.action.terminal_status_change',
    settings_create: 'AuditLogs.action.settings_create',
    settings_update: 'AuditLogs.action.settings_update',
    settings_delete: 'AuditLogs.action.settings_delete',
    permission_update: 'AuditLogs.action.permission_update',
    transaction_callback_resend: 'AuditLogs.action.transaction_callback_resend',
    transaction_decline: 'AuditLogs.action.transaction_decline',
    transaction_payout: 'AuditLogs.action.transaction_payout',
    transaction_amount_change: 'AuditLogs.action.transaction_amount_change',
};

// Маппинг типов объектов на русский
const ENTITY_TYPE_LABELS = {
    account: 'AuditLogs.entity.account',
    Account: 'AuditLogs.entity.Account',
    merchant: 'AuditLogs.entity.merchant',
    Merchant: 'AuditLogs.entity.Merchant',
    terminal: 'AuditLogs.entity.terminal',
    Terminal: 'AuditLogs.entity.Terminal',
    settings: 'AuditLogs.entity.settings',
    MerchantSettings: 'AuditLogs.entity.MerchantSettings',
    permission: 'AuditLogs.entity.permission',
    AccountAccess: 'AuditLogs.entity.AccountAccess',
    Transaction: 'AuditLogs.entity.Transaction',
};

const AuditLogsFilters = ({ actions = [], entityTypes = [], admins = [], onApplyFilters, isLoading }) => {
    const intl = useIntl();
    // Гарантируем, что это массивы
    const safeActions = Array.isArray(actions) ? actions : [];
    const safeEntityTypes = Array.isArray(entityTypes) ? entityTypes : [];
    const safeAdmins = Array.isArray(admins) ? admins : [];
    const [selectedAdmin, setSelectedAdmin] = useState('');
    const [selectedAction, setSelectedAction] = useState('');
    const [selectedEntityType, setSelectedEntityType] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    function handleApply() {
        const filters = {
            actorId: selectedAdmin ? parseInt(selectedAdmin, 10) : null,
            action: selectedAction || null,
            entityType: selectedEntityType || null,
            startDate: startDate || null,
            endDate: endDate || null,
            search: searchTerm || null,
        };
        onApplyFilters(filters);
    }

    function handleReset() {
        setSelectedAdmin('');
        setSelectedAction('');
        setSelectedEntityType('');
        setStartDate('');
        setEndDate('');
        setSearchTerm('');
        onApplyFilters({
            actorId: null,
            action: null,
            entityType: null,
            startDate: null,
            endDate: null,
            search: null,
        });
    }

    return (
        <div className={classes.Card}>
            <div className={classes.CardBody}>
                <div className={classes.FiltersRow}>
                    <div className={classes.FilterGroup}>
                        <label className={classes.Label}>{intl.formatMessage({ id: 'AuditLogsFilters.label.admin' })}</label>
                        <select
                            className={classes.Select}
                            value={selectedAdmin}
                            onChange={(e) => setSelectedAdmin(e.target.value)}
                            disabled={isLoading}
                        >
                            <option value="">{intl.formatMessage({ id: 'AuditLogsFilters.option.all' })}</option>
                            {safeAdmins.map((admin) => (
                                <option key={admin.id} value={admin.id}>
                                    {admin.username} ({admin.email})
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className={classes.FilterGroup}>
                        <label className={classes.Label}>{intl.formatMessage({ id: 'AuditLogsFilters.label.action' })}</label>
                        <select
                            className={classes.Select}
                            value={selectedAction}
                            onChange={(e) => setSelectedAction(e.target.value)}
                            disabled={isLoading}
                        >
                            <option value="">{intl.formatMessage({ id: 'AuditLogsFilters.option.allActions' })}</option>
                            {safeActions.map((action, idx) => {
                                // action может быть объектом {code, name} или строкой
                                const code = typeof action === 'object' ? action.code : action;
                                const name =
                                    typeof action === 'object'
                                        ? action.name
                                        : ACTION_LABELS[action]
                                          ? intl.formatMessage({ id: ACTION_LABELS[action] })
                                          : action;
                                return (
                                    <option key={code || idx} value={code}>
                                        {name}
                                    </option>
                                );
                            })}
                        </select>
                    </div>

                    <div className={classes.FilterGroup}>
                        <label className={classes.Label}>{intl.formatMessage({ id: 'AuditLogsFilters.label.entityType' })}</label>
                        <select
                            className={classes.Select}
                            value={selectedEntityType}
                            onChange={(e) => setSelectedEntityType(e.target.value)}
                            disabled={isLoading}
                        >
                            <option value="">{intl.formatMessage({ id: 'AuditLogsFilters.option.allTypes' })}</option>
                            {safeEntityTypes.map((type, idx) => {
                                // type может быть объектом {code, name} или строкой
                                const code = typeof type === 'object' ? type.code : type;
                                const name =
                                    typeof type === 'object'
                                        ? type.name
                                        : ENTITY_TYPE_LABELS[type]
                                          ? intl.formatMessage({ id: ENTITY_TYPE_LABELS[type] })
                                          : type;
                                return (
                                    <option key={code || idx} value={code}>
                                        {name}
                                    </option>
                                );
                            })}
                        </select>
                    </div>

                    <div className={classes.FilterGroup}>
                        <label className={classes.Label}>{intl.formatMessage({ id: 'AuditLogsFilters.label.periodFrom' })}</label>
                        <input
                            type="date"
                            className={classes.Input}
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            disabled={isLoading}
                        />
                    </div>

                    <div className={classes.FilterGroup}>
                        <label className={classes.Label}>{intl.formatMessage({ id: 'AuditLogsFilters.label.periodTo' })}</label>
                        <input
                            type="date"
                            className={classes.Input}
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            disabled={isLoading}
                        />
                    </div>

                    <div className={classes.FilterGroup}>
                        <label className={classes.Label}>{intl.formatMessage({ id: 'AuditLogsFilters.label.search' })}</label>
                        <input
                            type="text"
                            className={classes.Input}
                            placeholder={intl.formatMessage({ id: 'AuditLogsFilters.placeholder.search' })}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            disabled={isLoading}
                        />
                    </div>
                </div>

                <div className={classes.Actions}>
                    <button className={classes.BtnPrimary} onClick={handleApply} disabled={isLoading}>
                        {intl.formatMessage({ id: 'AuditLogsFilters.button.apply' })}
                    </button>
                    <button className={classes.BtnSecondary} onClick={handleReset} disabled={isLoading}>
                        {intl.formatMessage({ id: 'AuditLogsFilters.button.reset' })}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AuditLogsFilters;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/AuditLogsFilters/index.js